/* Video cards.
   Every card plays muted on its own while it is on screen — nobody has to press
   play. Tapping one opens a bigger player with sound.
   Browsers throttle a lot of videos at once, so the cards closest to the middle
   of the screen are the ones kept playing. */
(function(){
  var MAX_PLAYING = 8, walls = [], box = null, boxVideo = null, openNow = false;
  function middle(fig){
    var r = fig.getBoundingClientRect();
    return Math.abs((r.top + r.bottom) / 2 - (window.innerHeight || 0) / 2);
  }
  /* Measured from the card's own position, so a card can never be left paused on stale state. */
  function onScreen(fig){
    var r = fig.getBoundingClientRect(), vw = window.innerWidth || 0, vh = window.innerHeight || 0,
        w = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0)),
        h = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0)),
        area = r.width * r.height;
    return area > 0 && (w * h) / area >= 0.4;
  }
  var queued = false;
  function arrange(){
    if(queued) return;
    queued = true;
    setTimeout(function(){
      queued = false;
      var live = openNow ? [] : walls.filter(function(w){ return onScreen(w.fig); })
        .sort(function(a, b){ return middle(a.fig) - middle(b.fig); });
      walls.forEach(function(w){
        if(!w.v.muted && onScreen(w.fig)) w.play();
        else if(live.indexOf(w) > -1 && live.indexOf(w) < MAX_PLAYING) w.play();
        else if(!w.v.paused) w.v.pause();
        w.fig.classList.toggle('is-playing', !w.v.paused);
      });
    });
  }
  /* A bigger player over the page — not the whole screen. */
  function build(){
    if(box) return box;
    box = document.createElement('dialog');
    box.className = 'mm-vbox';
    box.innerHTML = '<button type="button" class="mm-vbox-x" aria-label="Close">✕</button>' +
                    '<div class="mm-vbox-in"></div>';
    box.querySelector('.mm-vbox-x').addEventListener('click', function(){ close(); });
    box.addEventListener('click', function(e){ if(e.target === box) close(); });
    box.addEventListener('close', function(){ clear(); });
    document.body.appendChild(box);
    return box;
  }
  function clear(){
    openNow = false;
    if(boxVideo){ boxVideo.pause(); boxVideo.remove(); boxVideo = null; }
    arrange();
  }
  function close(){
    if(box && box.open) box.close(); else clear();
  }
  function open(v, caption){
    build();
    clear();
    openNow = true;
    arrange();
    boxVideo = v.cloneNode(true);
    boxVideo.muted = false;
    boxVideo.controls = true;
    boxVideo.loop = false;
    boxVideo.setAttribute('playsinline', '');
    boxVideo.preload = 'auto';
    boxVideo.removeAttribute('style');
    var hold = box.querySelector('.mm-vbox-in');
    hold.textContent = '';
    hold.appendChild(boxVideo);
    if(caption){
      var p = document.createElement('p');
      p.className = 'mm-vbox-cap';
      p.textContent = caption;
      hold.appendChild(p);
    }
    if(box.showModal) box.showModal(); else box.setAttribute('open', '');
    boxVideo.currentTime = 0;
    boxVideo.play().catch(function(){});
  }
  function init(fig){
    if(fig.__mmV) return; fig.__mmV = true;
    var v = fig.querySelector('video'), mode = fig.getAttribute('data-mm-video');
    if(!v) return;
    if('IntersectionObserver' in window){
      var w = { fig: fig, v: v, tries: 0 };
      w.play = function(){
        if(openNow || fig.__held || !onScreen(fig)) return;
        if(v.preload === 'none') v.preload = 'metadata';
        v.play().catch(function(){});
        /* A first play() is sometimes dropped while the file is still loading — retry briefly. */
        if(v.paused && w.tries < 6){ w.tries++; setTimeout(function(){ arrange(); }, 400); }
      };
      walls.push(w);
      v.addEventListener('loadeddata', arrange);
      v.addEventListener('canplay', arrange);
      v.addEventListener('play', function(){ fig.classList.add('is-playing'); });
      v.addEventListener('pause', function(){ fig.classList.remove('is-playing'); });
      new IntersectionObserver(function(es){
        es.forEach(function(e){ if(!e.isIntersecting) w.tries = 0; arrange(); });
      }, { threshold: [0, 0.4, 0.8] }).observe(fig);
      window.addEventListener('scroll', arrange, { passive: true });
      window.addEventListener('resize', arrange, { passive: true });
      arrange();
    }
    /* pause and sound live on the card itself — nothing has to be clicked to start it */
    var hold = fig.querySelector('[data-mm-toggle]'), snd = fig.querySelector('[data-mm-cardsound]');
    if(hold) hold.addEventListener('click', function(e){
      e.stopPropagation();
      if(v.paused){ fig.__held = false; v.__paused = false; v.play().catch(function(){}); hold.innerHTML = '&#10073;&#10073;'; hold.setAttribute('aria-label','Pause'); }
      else { fig.__held = true; v.__paused = true; v.pause(); hold.innerHTML = '&#9654;'; hold.setAttribute('aria-label','Play'); }
    });
    if(snd) snd.addEventListener('click', function(e){
      e.stopPropagation();
      v.muted = !v.muted;
      v.__unmuted = !v.muted;
      if(!v.muted){ fig.__held = false; v.__paused = false; v.play().catch(function(){}); }
      snd.innerHTML = v.muted ? '&#128263;' : '&#128266;';
      snd.setAttribute('aria-pressed', String(!v.muted));
      snd.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
      if(!v.muted){
        document.querySelectorAll('[data-mm-video] video, video[data-mm-sound]').forEach(function(o){
          if(o !== v && !o.muted){
            o.muted = true;
            var of = o.closest('[data-mm-video]') || o.closest('.mm-sound-wrap');
            var ob = of && (of.querySelector('[data-mm-cardsound]') || of.querySelector('.mm-sound'));
            if(ob){ ob.setAttribute('aria-pressed','false'); var ic = ob.querySelector('.mm-sound-ico'); if(ic){ ic.textContent='🔇'; } else { ob.innerHTML='&#128263;'; } }
          }
        });
      }
    });
    fig.addEventListener('click', function(e){
      if(e.target.closest('a') || e.target.closest('.ugc-ctrls')) return;
      var cap = fig.querySelector('figcaption');
      open(v, cap ? cap.textContent.trim() : '');
    });
  }
  /* section videos that autoplay muted: one button turns their sound on */
  function sound(root){
    (root || document).querySelectorAll('video[data-mm-sound]').forEach(function(v){
      if(v.__mmS) return; v.__mmS = true;
      var wrap = v.closest('.mm-sound-wrap'); if(!wrap) return;
      var btn = wrap.querySelector('.mm-sound'); if(!btn) return;
      btn.addEventListener('click', function(){
        var on = v.muted;
        v.muted = !on;
        v.__unmuted = !v.muted;
        if(!v.muted){ v.play().catch(function(){}); }
        btn.setAttribute('aria-pressed', String(!v.muted));
        btn.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
        btn.querySelector('.mm-sound-ico').textContent = v.muted ? '🔇' : '🔊';
        /* only one of them plays sound at a time */
        if(!v.muted){
          document.querySelectorAll('video[data-mm-sound]').forEach(function(o){
            if(o !== v && !o.muted){
              o.muted = true;
              var ob = o.closest('.mm-sound-wrap') && o.closest('.mm-sound-wrap').querySelector('.mm-sound');
              if(ob){ ob.setAttribute('aria-pressed','false'); ob.querySelector('.mm-sound-ico').textContent='🔇'; }
            }
          });
        }
      });
    });
  }
  /* A muted autoplay video is occasionally dropped on its first try while the file
     is still arriving. One shared, throttled nudge covers them — never a listener
     per video, and nothing that runs while the page is being scrolled. */
  var selfs = [], nudgeAt = 0;
  function nudge(){
    var now = Date.now();
    if(now - nudgeAt < 1200) return;
    nudgeAt = now;
    for(var i = selfs.length - 1; i >= 0; i--){
      var v = selfs[i];
      if(v.__paused || v.__unmuted || !v.paused){ continue; }
      v.muted = true;
      v.play().catch(function(){});
    }
  }
  function selfstart(root){
    (root || document).querySelectorAll('video[autoplay][muted], video[data-mm-sound]').forEach(function(v){
      if(v.__mmA) return; v.__mmA = true;
      selfs.push(v);
      v.muted = true; v.defaultMuted = true; v.playsInline = true;
      ['loadedmetadata','loadeddata','canplay'].forEach(function(e){
        v.addEventListener(e, function(){
          if(v.paused && !v.__paused && !v.__unmuted) v.play().catch(function(){});
        });
      });
      if(v.readyState > 2 && v.paused) v.play().catch(function(){});
    });
    if(!selfstart.wired){
      selfstart.wired = true;
      /* a phone that holds autoplay until the page is touched gets one nudge, then we stop */
      ['touchstart','pointerdown'].forEach(function(e){
        document.addEventListener(e, nudge, { passive: true, once: true });
      });
      document.addEventListener('visibilitychange', nudge);
      var n = 0, t = setInterval(function(){ n++; nudge(); if(n > 14) clearInterval(t); }, 1500);
    }
  }
  function scan(root){
    sound(root);
    selfstart(root);
    (root || document).querySelectorAll('[data-mm-video]').forEach(init);
    /* Scroll and observer events can both be missed on a slow first load; this catches up. */
    if(walls.length && !scan.ticking){ scan.ticking = setInterval(arrange, 1000); }
  }
  scan();
  document.addEventListener('shopify:section:load', function(e){ scan(e.target); });
})();
